export const BASE_URL = process.env.REACT_APP_BASE_URL;


// "https://fv4qt3kj8g.execute-api.ap-south-1.amazonaws.com";
// export const BASE_URL = "http://localhost:8080";
